import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import "./Dashboard.css";
import ElectricalScoreDashboard from "../ElectricalScoreDashboard/ElectricalScoreDashboard";
import HSEDashboard from "../HSEDashboard/HSEDashboard";
import CmvElectricalDashboard from "../CmvElectricalDashboard/CmvElectricalDashboard";
import HseCmvDashboard from "../HseCmvDashboard/HseCmvDashboard";
import CsaDashboard from "../Csa/CsaDashboard";
import CsaSchedule from "../Csa/CsaSchedule";
const Dashboard = ({ allReports, getAllReports, allHseReports, getAllHseReports}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
//  console.log("data",allHseReports)
  useEffect(() => {
    // getAllReports();
    // getAllHseReports();
  }, []);

  return (
    <div className="dashboard">
      <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" >
        <Tab label="Electrical Dashboard" />
        <Tab label="HSE Dashboard" />
        <Tab label="CSA Trend" />
        <Tab label="CSA Schedule" />
      </Tabs>
      {activeTab === 0 && <CmvElectricalDashboard allReports={allReports} />}
      {activeTab === 1 && <HseCmvDashboard allHseReports={allHseReports} />}
      {/* CSA fetches its own data through csaApi — it does not read
          allReports, which comes from the endpoint that interpolates a user id
          from the query string. */}
      {activeTab === 2 && <CsaDashboard />}
      {/* The PM view: every auditor, not one team — see §7d. The server
          refuses it to anyone without ProjectManager or Admin. */}
      {activeTab === 3 && <CsaSchedule />}
    </div>
  );
};

export default Dashboard;


